import React from 'react';
import MovieCard from './MovieCard';

function MovieGrid({ movies }) {
  return (
    <div className="movies-grid">
      {movies.map((movie) => (
        <MovieCard key={movie.imdbID} movie={movie} />
      ))}
    </div>
  );
}

export default MovieGrid;